module.exports = __webpack_public_path__ + "img/code-repo.5637a035.jpg";